import { request } from "services/request";

const resource = "api/init";

const loadConfigsData = () => request(`${resource}/getInitialSettings`, { method: "GET" });

export { loadConfigsData };
